import Vuex from 'vuex';
import Vue from 'vue';
import { StoreModule } from './const';
import carStore from './modules/admin/car';
import GoodsStore from './modules/admin/goods';
import LeagueStore from './modules/admin/league';
import distributionStore from './modules/admin/distribution';
import promotionState from './modules/admin/promotion';
import MenuStore from './modules/menu';
import CustomerServiceStore from './modules/customer-service';
import ShopStore from './modules/admin/shop';
import PayBindingStore from './modules/admin/pay-binding';
import notificationStore from './modules/admin/notification';

import RootState from './state';
import { SET_USERINFO, CLEAR_USERINFO, SET_PERMIT_RESOURCES, UPDATE_USERINFO } from './type';
import { getAccountList, getMerchantInfo, getUserPermitResource } from '../../services/user';
import { transformPermit } from '../../utils/permission/util';

Vue.use(Vuex);

export default function createStore(initState: any = {}) {
    const {
        title,
        url,
        origin,
        locale,
        csrf,
        userInfo,
        source,
        settleSource,
        bdOperateCode,
        ssr,
        loginConfig,
        bizUrl,
        menu,
        form,
        attrs,
        permitResources,
    } = initState;
    const state = {
        title,
        url,
        origin,
        locale,
        csrf,
        userInfo,
        source,
        settleSource,
        bdOperateCode,
        ssr,
        loginConfig,
        bizUrl,
        form,
        attrs,
        permitResources,
        // permitResources: {
        //     btn: {},
        //     page: {},
        // },
    };
    return new Vuex.Store<RootState>({
        state,
        modules: {
            [StoreModule.YELLOWCAR]: carStore,
            [StoreModule.DISTRIBUTION]: distributionStore,
            menu: new MenuStore(menu),
            [StoreModule.GOODS]: GoodsStore,
            [StoreModule.LEAGUE]: LeagueStore,
            [StoreModule.PROMOTION]: promotionState,
            customerService: new CustomerServiceStore({
                customerService: {
                    groupId: '',
                },
            }),
            [StoreModule.SHOP]: ShopStore,
            [StoreModule.PAY_BINDING]: PayBindingStore,
            [StoreModule.NOTIFICATION]: notificationStore,
        },
        getters: {
            loginConfig(state): any {
                return state.loginConfig;
            },
            bizUrl(state): any {
                return state.bizUrl;
            },
            userInfo(state): any {
                return state.userInfo;
            },
            formConfig(state): any {
                return state.form;
            },
            attrs(state): any {
                return state.attrs;
            },
            settleSource(state): string {
                return state.settleSource;
            },
            bdOperateCode(state): string {
                return state.bdOperateCode;
            },
            permitResources(state): any {
                return state.permitResources;
            },
        },
        actions: {
            setUserInfo({ commit }, payload) {
                commit(SET_USERINFO, payload);
            },
            async getPermit({ commit }) {
                try {
                    const res: any = await getUserPermitResource();
                    commit('SET_PERMIT_RESOURCES', transformPermit(res?.data));
                } catch (err: any) {
                    console.log('get permit error', err);
                    throw new Error(err);
                }

            },
            async getUserInfo() {
                try {
                    const res = await getAccountList();
                    return res;
                } catch (err: any) {
                    console.log('get userInfo error', err);
                    throw new Error(err);
                }
            },
            // async getMerchantInfo(_, params) {
            //     const res = await getMerchantInfo(params);
            //     return res;
            // },
        },
        mutations: {
            [SET_PERMIT_RESOURCES](state, payload) {
                state.permitResources = payload;
            },
            [SET_USERINFO](state, payload) {
                state.userInfo = payload;
            },
            [UPDATE_USERINFO](state, payload) {
                state.userInfo = {
                    ...state.userInfo,
                    ...payload,
                };
            },
            [CLEAR_USERINFO](state) {
                state.userInfo = {
                    userName: '',
                    userRole: -1,
                    loginStatus: false,
                };
            },
        },
    });
}
